import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router";
import { MeldenHost } from "../components/Melden";
import { Ladeschirm } from "../components/Ladeschirm";
import { api } from "../data";
import { router } from "./routes";
import { SessionProvider } from "./session";
import { ZweiterFaktorGate } from "./ZweiterFaktor";
import { retryAusserEinrichtung } from "../lib/einrichtung";
import { appGezeichnet } from "../lib/ladeschirm";
import { neuLadenBeiAenderung } from "../data/neuladen";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: retryAusserEinrichtung, refetchOnWindowFocus: false } },
});

/**
 * Nach Datenänderungen neu laden (data/neuladen.ts): eigene Schreibaktionen laden alles außer dem Konto, Echtzeit-Ereignisse
 * nur die Abfragen zur geänderten Tabelle. Änderungen kurz hintereinander bündelt eine Entprellung (500 ms, spätestens
 * nach 2 s), und was nach der Änderung schon frisch geladen wurde, lädt nicht noch einmal. So kann eine Kette von
 * Meldungen die Seite nie blockieren.
 */
function DataRefresh() {
  useEffect(() => neuLadenBeiAenderung(queryClient, (cb) => api.onDataChange(cb)), []);
  return null;
}

export function App() {
  // Erstes Zeichnen: der Ladeschirm aus index.html geht, sobald ihn keine Stelle mehr hält (Start, Konto, Suspense)
  useEffect(() => appGezeichnet(), []);
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <DataRefresh />
        <ZweiterFaktorGate>
          <Suspense fallback={<Ladeschirm />}>
            <RouterProvider router={router} />
          </Suspense>
          <MeldenHost />
        </ZweiterFaktorGate>
      </SessionProvider>
    </QueryClientProvider>
  );
}
